import React, { useState, useEffect } from "react";
import Table from "../../../core/pagination/datatable";
import { Link } from "react-router-dom";
import { Spin, Tooltip, Select, DatePicker } from "antd";
import { getApiBaseUrl } from "../Config/Config";
import dayjs from "dayjs";
const { Option } = Select;
const { RangePicker } = DatePicker;

const AlarmsDeviations = () => {
  const [deviationsAlarms, setDeviationsAlarms] = useState([]);
  const [deviationsLoading, setDeviationsLoading] = useState(false);
  const [dateRange, setDateRange] = useState([
    dayjs().subtract(30, "days"),
    dayjs(),
  ]);
  const [selectedUserId, setSelectedUserId] = useState(0);
  const [users, setUsers] = useState([]);

  const fetchDeviationsAlarms = async () => {
    setDeviationsLoading(true);
    try {
      const startDate = dateRange[0].format("YYYY-MM-DD");
      const endDate = dateRange[1].format("YYYY-MM-DD");
      const response = await fetch(
        `${getApiBaseUrl()}/api/getDeviationsReport?userid=${selectedUserId}&startdate=${startDate}&enddate=${endDate}&Filterid=0`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        }
      );
      const data = await response.json();
      if (data.Status && Array.isArray(data.ResultData)) {
        setDeviationsAlarms(data.ResultData);
      } else {
        setDeviationsAlarms([]);
      }
    } catch (error) {
      console.error("Error fetching barcode data:", error);
      setDeviationsAlarms([]);
    } finally {
      setDeviationsLoading(false);
    }
  };

  useEffect(() => {
    fetch(`${getApiBaseUrl()}/api/getAllUsers`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((res) => res.json())
      .then((data) => setUsers(data?.ResultData || []))
      .catch(() => setUsers([]));
  }, []);

  useEffect(() => {
    fetchDeviationsAlarms();
  }, [dateRange, selectedUserId]);

  const columns = [
    {
      title: "Date",
      dataIndex: "CreatedOn",
      key: "date",
      render: (text) => dayjs(text).format("DD/MM/YYYY"),
      sorter: (a, b) => new Date(a.CreatedOn) - new Date(b.CreatedOn),
    },
    {
      title: "Time",
      dataIndex: "CreatedOn",
      key: "time",
      render: (text) => dayjs(text).format("HH:mm:ss"),
      sorter: (a, b) => dayjs(a.CreatedOn).unix() - dayjs(b.CreatedOn).unix(), // sort by time
    },
    {
      title: "User ID",
      dataIndex: "username", // assuming userId = username like "ravi@company.com"
      key: "userId",
      sorter: (a, b) => a.username.localeCompare(b.username),
    },
    {
      title: "Filter ID",
      dataIndex: "Lable",
      key: "Lable",
      sorter: (a, b) => a.Lable.localeCompare(b.Lable),
    },
    {
      title: "AHU",
      dataIndex: "ahucode",
      key: "ahu",
      sorter: (a, b) => a.ahucode.localeCompare(b.ahucode),
    },
    {
      title: "Block",
      dataIndex: "BlockName",
      key: "block",
      sorter: (a, b) => a.BlockName.localeCompare(b.BlockName),
    },
    {
      title: "Description of Deviation",
      dataIndex: "remarks", // assuming remarks is used as deviation description
      key: "deviationDescription",
      sorter: (a, b) => a.remarks.localeCompare(b.remarks),
      render: (text) => (
        <Tooltip title={text}>
          {text?.length > 20 ? text.slice(0, 20) + "..." : text}
        </Tooltip>
      ),
    },
  ];

  const handleDateRangeChange = (dates) => {
    if (dates) {
      setDateRange(dates);
    } else {
      setDateRange([dayjs().subtract(30, "days"), dayjs()]);
    }
  };

  const handleUserChange = (value) => {
    setSelectedUserId(value);
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/assetmgt/dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item " aria-current="page">
                    Alarms & Deviations
                  </h4>
                </ol>
              </nav>
              <h6>Find Deviations here </h6>
            </div>
          </div>
        </div>
        <div className="card table-list-card">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            <div className="search-set mt-4"></div>
            <div className="d-flex table-dropdown my-xl-auto right-content align-items-end flex-wrap gap-3">
              <div style={{ width: 200 }}>
                <label>Users</label>
                <Select
                  style={{ width: "100%" }}
                  value={selectedUserId === 0 ? 0 : selectedUserId}
                  onChange={handleUserChange}
                  placeholder="Select Username"
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option?.children
                      ?.toLowerCase()
                      .includes(input.toLowerCase())
                  }
                >
                  <Option key={0} value={0}>
                    All
                  </Option>
                  {users?.map((user) => (
                    <Option key={user?.UserID} value={user?.UserID}>
                      {user?.Username}
                    </Option>
                  ))}
                </Select>
              </div>
              <div style={{ width: 250 }}>
                <label>Date range</label>
                <RangePicker
                  value={dateRange}
                  onChange={handleDateRangeChange}
                  format="DD-MM-YYYY"
                  //   style={{ width: 100% }}
                  defaultValue={[dayjs().subtract(30, "days"), dayjs()]}
                />
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              {deviationsLoading ? (
                <div className="text-center my-4">
                  <Spin size="large" />
                  <p>Loading data...</p>
                </div>
              ) : deviationsAlarms?.length > 0 ? (
                <Table columns={columns} dataSource={deviationsAlarms} />
              ) : (
                <p className="text-center my-4">No data available</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlarmsDeviations;
